var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['quiz-completion-badge', _vm.statusClass]},[_c('v-img',{staticClass:"quiz-badge-icon",attrs:{"src":require('@components/assets/QuizzImpactOnInspection.svg')}}),_c('span',{staticClass:"quiz-badge-label"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }